import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import type { UserEnterprisesCollection } from './user-enterprises.types';
import { transformUserEnterprise } from '../admin-user-enterprises/admin-user-enterprises.transformers';

export function userEnterprisesReducer(
  state: CollectionStateSlice<UserEnterprisesCollection> = {},
  action: CollectionActions<UserEnterprisesCollection>,
): CollectionStateSlice<UserEnterprisesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'userEnterprises') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UserEnterprisesCollection>(
          state,
          transformIntoDocuments(
            result.user_enterprises,
            transformUserEnterprise,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
